import {
  cancelIntercityOrderFn,
  type CancelIntercityOrderRequestBody,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useCancelIntercityOrder = (
  opts?: UseMutationOptions<
    NonNullable<unknown>,
    DefaultQueryError,
    CancelIntercityOrderRequestBody
  >
) =>
  useMutation<
    NonNullable<unknown>,
    DefaultQueryError,
    CancelIntercityOrderRequestBody
  >({
    mutationFn: cancelIntercityOrderFn,
    ...opts,
  });
